import {
    ADDIBANPROVIDER_SUCCESS,
    ADDIBANPROVIDER_FAILED,
    RESET_ADDIBANPROVIDER,
    LOADING_ADDIBANPROVIDER,
    NETWORK_ERROR_ADDIBANPROVIDER
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminAddIbanProviderList = () => {
    return { type: RESET_ADDIBANPROVIDER };
};

const getAddIbanProviders = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDIBANPROVIDER });
    await adminServices
        .post("addIbanProvider", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminAddIbanProviderSuccess(res.data));
                    break;
                default:
                    dispatch(adminAddIbanProviderFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDIBANPROVIDER,
                payload: err
            });
        });
};


function adminAddIbanProviderSuccess(data) {
    return {
        type: ADDIBANPROVIDER_SUCCESS,
        payload: data
    };
}
function adminAddIbanProviderFailed(data) {
    return {
        type: ADDIBANPROVIDER_FAILED,
        payload: data
    };
}

export { getAddIbanProviders, resetAdminAddIbanProviderList }